export enum ExpandableIconType {
    Primary = 'primary',
    MenuLevel1 = 'menu-level-1',
    MenuLevel2 = 'menu-level-2',
}

export default interface IProps {
    isExpanded: boolean
    isActive?: boolean
    type?: string | ExpandableIconType
    className?: string
    toggleExpanded?: Function
}
